export * from './loyalty-for-member-rewards.shared.component';
export * from './loyalty-for-member-rewards.shared.module';
